export enum MetodoPagamento {
    'Dinheiro' = 'Dinheiro',
    'Pix' = 'Pix',
    'Cartão' = 'Cartão',
    'Débito' = 'Débito',
    'Voucher' = 'Voucher',
    'Crédito' = 'Crédito',
    'Refeição' = 'Refeição',
    'Alimentação' = 'Alimentação'
}